import packageJson from '../package.json';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

// +++ EXAMPLE_DATA +++


// +++ SETTINGS +++

// export var APPMODE = "prod" //CHANGE YOUR MODE: prod,dev,local,pre
export var APPMODE = packageJson.appmode;

const URL_STRAPI_LOCAL = "http://localhost:1337"
// const URL_STRAPI_LOCAL = "https://dev-strapi.tonetwork.de"
const URL_STRAPI_DEV = "https://web-strapi.tonetwork.de"
const URL_STRAPI_PRE = "https://web-strapi.tonetwork.de"
// const URL_STRAPI_PROD = "https://strapi.tonetwork.de"
const URL_STRAPI_PROD = "https://web-strapi.tonetwork.de"

export const API_TOKEN_STRAPI_LOCAL = "6dc6133ddfe9190607609c2455da8b098660808b10ae7afe3ae04dde8c5f57f71dfb216993567b79faa5f9be1d72e646c0c12b487f30a4bfe54634a1c804b64de02706523878c094c4cba07470e3db74d4b179ce43f135d0f9e762f99acd74890b60bcd22f584a96bee8b719dce102c757e5bb3f7aff6919f23f671a3c30b36b"
// export const API_TOKEN_STRAPI_LOCAL = "297fa73bdd36f001bb32a8603154aa61944d3562f6d1f45ba2e4bd917f62ec821d49eeb9d3582a034acea818c06f590df462f09d930a698fb87af65f7eca537717bde0c8c0fa1964d51e183baaea1aad35e61767a551418f82467270268459774a79ee25cd7b290a248b1302c03195723e6b8aa1fc2eda355ddf953744705632"
export const API_TOKEN_STRAPI_DEV = "a207d51edbf848a0a5165f9ccfd2c455c7b3cd8b9d2688b08dafaf052213f67361126028da1a3ef625b9ce8b9f43d3f4a240ef9cb2a9614655bbc30694321c2306316562c956c525e6ca39175940496bebb84e5aba6a562d82610a040be512500e604dfe7587950486cedca15341c7549d3a8f3252996ec899ec4e7aa0ab11f7"
export const API_TOKEN_STRAPI_PRE = "a207d51edbf848a0a5165f9ccfd2c455c7b3cd8b9d2688b08dafaf052213f67361126028da1a3ef625b9ce8b9f43d3f4a240ef9cb2a9614655bbc30694321c2306316562c956c525e6ca39175940496bebb84e5aba6a562d82610a040be512500e604dfe7587950486cedca15341c7549d3a8f3252996ec899ec4e7aa0ab11f7"
// export const API_TOKEN_STRAPI_PROD = ""
export const API_TOKEN_STRAPI_PROD = "a207d51edbf848a0a5165f9ccfd2c455c7b3cd8b9d2688b08dafaf052213f67361126028da1a3ef625b9ce8b9f43d3f4a240ef9cb2a9614655bbc30694321c2306316562c956c525e6ca39175940496bebb84e5aba6a562d82610a040be512500e604dfe7587950486cedca15341c7549d3a8f3252996ec899ec4e7aa0ab11f7"


// +++ CORE FUNCTIONS +++

export var URL_STRAPI = (APPMODE == "prod") ? URL_STRAPI_PROD : (APPMODE == "dev") ? URL_STRAPI_DEV : (APPMODE == "pre") ? URL_STRAPI_PRE : URL_STRAPI_LOCAL
export var API_TOKEN_STRAPI = (APPMODE == "prod") ? API_TOKEN_STRAPI_PROD : (APPMODE == "dev") ? API_TOKEN_STRAPI_DEV : (APPMODE == "pre") ? API_TOKEN_STRAPI_PRE : API_TOKEN_STRAPI_LOCAL

export const TONI_SUMMARY_STORAGE_KEY = 'toni_chat_summary';
export const TONI_CONTACT_STORAGE_KEY = 'toni_chat_contact';
/** Max. Zeichen für ToNi-Zusammenfassung in E-Mail / HubSpot-URL (mailto- und URL-Längenlimit). */
export const TONI_MAIL_MESSAGE_MAX_CHARS = 4000;

/** localStorage (nicht sessionStorage) – damit neuer Tab /support?from=toni die Zusammenfassung sieht. */
export function saveToniSummary(text) {
    try { localStorage.setItem(TONI_SUMMARY_STORAGE_KEY, text) } catch (e) { /* quota / private mode */ }
}

export function getToniSummary() {
    try { return localStorage.getItem(TONI_SUMMARY_STORAGE_KEY) } catch (e) { return null }
}

/** Im Chat erfasste Kontaktdaten (Name, E-Mail, Telefon) für das Kontaktformular zwischenspeichern. */
export function saveToniContact(contact) {
    try { localStorage.setItem(TONI_CONTACT_STORAGE_KEY, JSON.stringify(contact || {})) } catch (e) { /* quota / private mode */ }
}

export function getToniContact() {
    try {
        const raw = localStorage.getItem(TONI_CONTACT_STORAGE_KEY)
        return raw ? JSON.parse(raw) : null
    } catch (e) { return null }
}

export var APPVERSION = packageJson.version;
export var APPNAME = packageJson.name;
export var APPVERSIONDATE = packageJson.versiondate;

export function lP(url) {
    window.location.href = url
}
export function oP(url) {
    window.open(url)
}

export function oPU(url) {
    const windowFeatures = "left=400,top=200,width=1000,height=800,toolbar=0,menubar=0,location=0";
    window.open(url, "ToNetwork", windowFeatures)
}
export function sT(element) {
    window.scroll({
        behavior: 'smooth',
        left: 0,
        top: document.querySelector(element).offsetTop - 120
    })
}

export function urlBeautify(val) {
    let url = String(val).replace("https://", "");
    url = url.replace("http://", "");
    const parts = url.split("/");
    // return parts.slice(0, parts.length - 1).join("/");
    return parts[0];
}

export function capFirstChar(val) {
    return String(val).charAt(0).toUpperCase() + String(val).slice(1);
}

export const boxvar1 = {
    visible: { opacity: 1, scale: 1, y: 0, transition: { duration: 0.5 } },
    hidden: { opacity: 0, scale: 0.7, y: 50, transition: { duration: 0.5 } },
}
export const boxvar2 = {
    visible: { opacity: 1, x: 0, transition: { duration: 0.5 } },
    hidden: { opacity: 0, x: 50, transition: { duration: 0.5 } },
}
export const boxvar2dyndelay = {
    visible: (customDelay = 0.0) => ({ opacity: 1, x: 0, transition: { duration: 0.5, delay: customDelay } }),
    hidden: (customDelay = 0.0) => ({ opacity: 0, x: 50, transition: { duration: 0.5, delay: 0.0 } }),
}
export const boxvar2_1 = {
    visible: { opacity: 1, x: 0, transition: { duration: 0.5, delay: 0.3 } },
    hidden: { opacity: 0, x: 50, transition: { duration: 0.5, delay: 0.3 } },
}
export const boxvar2_2 = {
    visible: { opacity: 1, x: 0, transition: { duration: 0.5, delay: 0.6 } },
    hidden: { opacity: 0, x: 50, transition: { duration: 0.5, delay: 0.6 } },
}
export const boxvar2_3 = {
    visible: { opacity: 1, x: 0, transition: { duration: 0.5, delay: 0.9 } },
    hidden: { opacity: 0, x: 50, transition: { duration: 0.5, delay: 0.9 } },
}
export const boxvar3 = {
    visible: { opacity: 1, scale: 1, x: 0, transition: { duration: 0.5 } },
    hidden: { opacity: 0, scale: 0.8, x: 0, transition: { duration: 0.5 } },
}
export const boxvar4 = {
    visible: { opacity: 1, scale: 1, transition: { duration: 0.7 } },
    hidden: { opacity: 0, scale: 1, transition: { duration: 0.7 } },
}
export const boxvar2_1l = {
    visible: { opacity: 1, x: 50, transition: { duration: 0.5, delay: 0.3 } },
    hidden: { opacity: 0, x: 0, transition: { duration: 0.5, delay: 0.3 } },
}
export const boxvar2_2l = {
    visible: { opacity: 1, x: 50, transition: { duration: 0.5, delay: 0.6 } },
    hidden: { opacity: 0, x: 0, transition: { duration: 0.5, delay: 0.6 } },
}
export const boxvar2_3l = {
    visible: { opacity: 1, x: 50, transition: { duration: 0.5, delay: 0.9 } },
    hidden: { opacity: 0, x: 0, transition: { duration: 0.5, delay: 0.9 } },
}

export function generateUUID() {
    var d = new Date().getTime();
    var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now() * 1000)) || 0;//Time in microseconds since page-load or 0 if unsupported
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16;
        if (d > 0) {
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
}

export function getBrowser(UAvar) {
    var sUsrAg = UAvar
    var sBrowser = ""

    if (sUsrAg.indexOf("Firefox") > -1) {
        sBrowser = "Mozilla Firefox"
    } else if (sUsrAg.indexOf("SamsungBrowser") > -1) {
        sBrowser = "Samsung Internet"
    } else if (sUsrAg.indexOf("Opera") > -1 || sUsrAg.indexOf("OPR") > -1) {
        sBrowser = "Opera"
    } else if (sUsrAg.indexOf("Trident") > -1) {
        sBrowser = "Microsoft Internet Explorer"
    } else if (sUsrAg.indexOf("Edge") > -1) {
        sBrowser = "Microsoft Edge"
    } else if (sUsrAg.indexOf("Chrome") > -1) {
        sBrowser = "Google Chrome"
    } else if (sUsrAg.indexOf("Safari") > -1) {
        sBrowser = "Apple Safari"
    } else {
        sBrowser = "unknown"
    }
    return { 'browser': sBrowser, 'agent': sUsrAg }
}

export function formatDateWithTime(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Monate sind 0-basiert
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes} Uhr`;
}

export function flattenObject(obj, parentKey = '') {
    let result = {};
    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            const newKey = parentKey ? `${parentKey}.${key}` : key; // Verschachtelte Keys mit Punkt verbinden
            if (typeof obj[key] === 'object' && obj[key] !== null) {
                Object.assign(result, flattenObject(obj[key], newKey)); // Rekursiv flach machen
            } else {
                result[newKey] = obj[key];
            }
        }
    }
    return result;
}

export function convertToCSV(data) {
    const flatData = data.map(item => flattenObject(item));
    const headers = Object.keys(flatData[0]);
    const csvRows = [];
    csvRows.push(headers.join(','));
    for (const row of flatData) {
        const values = headers.map(header => {
            let value = row[header];
            if (typeof value === 'string' && value.includes(',')) {
                value = `"${value}"`;
            }
            if (typeof value === 'object') {
                value = JSON.stringify(value);
            }
            return value;
        });
        csvRows.push(values.join(','));
    }
    return csvRows.join('\n');
}

export function downloadCSV(csvContent, filename) {
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    if (link.download !== undefined) {
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        link.click();
    }
}

export function getAge(dateString) {
    var today = new Date();
    var birthDate = new Date(dateString);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }
    return age;
}

export function MarkdownViewer({ content }) {
    return (
        <ReactMarkdown
            children={content}
            remarkPlugins={[remarkGfm]}
            components={{
                a: ({ node, ...props }) => (
                    <a
                        {...props}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ textDecoration: 'underline' }}
                    />
                ),
            }}
        />
    );
}